module.exports = __webpack_public_path__ + "media/assets/images/blog/DALL·E_customer_experience-229718ee862e3949783e3b06fd84b087.png";